export const calculateAmountBigInt = async (amount, tokenContract) => {
    const decimals = await tokenContract.decimals();
    return amount.shl(Number(decimals)).quotient;
};
